import { createCRUDHook } from './createCRUDHook';
import { HeaderDto } from 'utils/models';
import { TLKP_HEADER } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<HeaderDto>({
  entityName: 'Header',
  endpoint: TLKP_HEADER,
});

export const HeaderContext = Context;
export const useHeaderManager = useManager;
export const useHeader = useConsumer;
